import { render, staticRenderFns } from "./compare.vue?vue&type=template&id=664ccb6a&scoped=true&"
import script from "./compare.vue?vue&type=script&lang=js&"
export * from "./compare.vue?vue&type=script&lang=js&"
import style0 from "./compare.vue?vue&type=style&index=0&id=664ccb6a&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "664ccb6a",
  null
  
)

export default component.exports